export const defaultFilter = () => {
    return {
        company_id: null,
        slq_location_id: null,
        type: null,
        page: 1,
        per_page: 10,
    }
}

export default {
    company_id: null,
    products: {data: []},
    dcr_historical_imports_pr: [],
    backgroundProcess: [],
    components: [],
    quantity_purchased_kg: 0,
    withDensity: [190, 191, 193, 902]
}
